import React, { useState } from 'react';
import Carousel from 'react-multi-carousel';
import { KuposModal, SvgHome } from '../../../common';


const ThemeNineTitle = props => {
  const [state, setState] = useState('');
  return (
    <div className='theme-nine-title' style={{display:'flex',flexDirection:'column',alignItems:'center',marginTop:40, marginBottom:30}}>
         <div className='title' style={{fontWeight:'bolder' ,fontSize:'17pt',color: props.whiteHeading ? "#fff" : '#000'}}>{props.title}</div>
         <div className='orange-line'></div>
    </div>
  );
};


export default ThemeNineTitle;



// WEBPACK FOOTER //
// ./src/features/themes/ThemeNine/common/ThemeNineTitle.js